<footer class="site-footer">
  <div class="site-footer__inner">
    <div class="site-footer__brand">
      <img
        class="site-footer__logo"
        src="../../../assets/logos/xfabricsVerticalWhite.png"
        alt=""
        aria-hidden="true"
      />
      <p class="site-footer__pitch">
        {{ 'Premium fabrics & custom quotations' | t }}
      </p>
    </div>

    <!-- Sitemap columns -->
    @for (column of columns; track column.title) {
      <nav class="site-footer__col" [attr.aria-label]="column.title | t">
        <h2 class="site-footer__col-title">{{ column.title | t }}</h2>
        <ul class="site-footer__links">
          @for (link of column.links; track link.route) {
            <li>
              <a [routerLink]="link.route">{{ link.label | t }}</a>
            </li>
          }
        </ul>
      </nav>
    }

    <!-- Contact — the owner's own details, not a repeat of the legal bar -->
    @if (company(); as info) {
      <div class="site-footer__col site-footer__col--contact">
        <h2 class="site-footer__col-title">{{ 'Contact' | t }}</h2>
        <ul class="site-footer__contact">
          @if (info.addressLines.length) {
            <li>
              <span nz-icon nzType="environment" aria-hidden="true"></span>
              <address class="site-footer__address">
                @for (line of info.addressLines; track line) {
                  <span>{{ line }}</span>
                }
              </address>
            </li>
          }
          @if (info.phone) {
            <li>
              <span nz-icon nzType="phone" aria-hidden="true"></span>
              <a [href]="'tel:' + info.phone">{{ info.phone }}</a>
            </li>
          }
          @if (info.email) {
            <li>
              <span nz-icon nzType="mail" aria-hidden="true"></span>
              <a [href]="'mailto:' + info.email">{{ info.email }}</a>
            </li>
          }
          @if (info.websiteUrl; as websiteUrl) {
            <li>
              <span nz-icon nzType="global" aria-hidden="true"></span>
              <a [href]="websiteUrl" target="_blank" rel="noopener noreferrer">
                {{ info.website }}
              </a>
            </li>
          }
        </ul>
      </div>
    }
  </div>

  <div class="site-footer__bar">
    <span class="site-footer__copy">
      &copy; {{ currentYear }} {{ company()?.name || ('XFabrics B2B' | t) }}
    </span>

    <nav class="site-footer__legal" [attr.aria-label]="'Legal' | t">
      <a routerLink="/privacy-policy">{{ 'Privacy Policy' | t }}</a>
      <a routerLink="/terms-conditions">{{ 'Terms and conditions' | t }}</a>
      <a routerLink="/faq">{{ 'FAQ' | t }}</a>
    </nav>
  </div>
</footer>
